/**
 * The application: providers, a router, and nothing else.
 *
 * What happens when a session ends lives in the providers, beside the thing
 * that notices it.
 */
import { BrowserRouter } from "react-router";

import { Providers } from "./providers";
import { AppRoutes } from "./routes";

export function App(): React.JSX.Element {
  return (
    <Providers>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Providers>
  );
}
